/**
 * @fileoverview Shared Resource schema used by both frontend and backend.
 */

import { z } from 'zod';
import { createCrudSchemas, createDisplayableEntitySchema, getSchemaFields } from './base.js';
import { ID_PATTERNS } from './types.js';

export const ResourceSchema = createDisplayableEntitySchema(
  ID_PATTERNS.RESOURCE,
  'ID must be in re-prefixed nanoid7 format',
  { archivable: true, accountTracking: 'archivable' }
);

const { CreateSchema, UpdateSchema } = createCrudSchemas(ResourceSchema);

export const ResourceCreateSchema = CreateSchema;
export const ResourceUpdateSchema = UpdateSchema;

export type Resource = z.infer<typeof ResourceSchema>;
export type ResourceCreate = z.infer<typeof ResourceCreateSchema>;
export type ResourceUpdate = z.infer<typeof ResourceUpdateSchema>;

export const RESOURCE_FIELDS = getSchemaFields(ResourceSchema);
